import React from 'react';
import { Textarea } from '@iq/react-components';

const TextareaWidget = ({
  value,
  schema: {
    default: defaultValue,
    disabled,
    readonly,
    required: customRequired,
    placeholder,
    editable = true,
    rows = 5,
  },
  required,
  onChange,
}) => {
  const defaultValue_ = defaultValue;
  const useDefault = !value;
  const value_ = useDefault ? defaultValue_ : value;
  const viewRows = Math.ceil(Math.min(rows, (value_?.length || 1) / 25));

  return (
    <>
      {editable ? (
        <Textarea
          required={required || customRequired}
          disabled={disabled}
          readOnly={readonly}
          placeholder={placeholder}
          rows={rows}
          defaultValue={value_}
          onChange={(event) => {
            let v = event.target.value;
            if (typeof v === 'string') {
              v = v.trim();
            }
            onChange(v);
          }}
        />
      ) : (
        <Textarea
          readOnly={true}
          rows={viewRows}
          value={value_}
          className="view-widget"
        />
      )}
    </>
  );
};

export default TextareaWidget;
